function checkRequiredProperty(json, flds, callback) {
  let msg = '';
  let valid = true;

  for (const f of flds) {
    if (!json[f] || `${json[f]}`.trim().length === 0) {
      msg += (msg === '' ? '' : '\n') + `${f} is required.`;
      valid = false;
    }
  }

  if (callback) {
    callback(valid ? null : msg);
  }

  return valid;
}

/**
 * Assign new key for sub value eg. json['key.sub']
 * @param {*} json
 */
function makeKeySubValue(json) {
  for (const key in json) {
    if (Object.hasOwnProperty.call(json, key)) {
      const element = json[key];
      if (typeof element === 'object') {
        for (const sub in element) {
          if (Object.hasOwnProperty.call(element, sub)) {
            json[`${key}.${sub}`] = json[key][sub];
          }
        }
      }
    }
  }
}

function jsonToQueryString(json) {
  return (
    '?' +
    Object.keys(json)
      .map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
      })
      .join('&')
  );
}
module.exports = {
  checkRequiredProperty,
  makeKeySubValue,
  jsonToQueryString,
};
